define('modules/image_picker/image_picker_view',[
	'backbone',
	'jquery',
	'_',

	'modules/util/collection/collection_view',
	'./image_picker_image_item_view',
	'modules/modal/modal_view',
	'./image_picker_collection',
	'text!./image_picker_template.html'
	], function(Backbone, $, _,
		CollectionView,
		imageItemView,
		ModalView,
		ImagesCollection,
		template) {
		'use strict';
		var ImagePickerView = Backbone.View.extend({
			initialize: function (opts) {

				_.extend(this, opts);
				this.collection = new ImagesCollection({}, {endpoint: this.endpoint});
				if (this.limit) {
        	this.collection.params = _.extend(this.collection.params, {limit: this.limit});
      	}

      	if(this.filter_id) {
        	this.collection.params = _.extend(this.collection.params, {filter_id: this.filter_id});
      	}

				this.listenToOnce(this.collection, 'sync', function () {
					this.initializeModal();
				}, this);

				this.collection.fetch();
			},
			template: _.template(template),
			className: 'ImagePickerModal',
			render: function () {

				this.$el.html(this.template());

				this.collectionView = new CollectionView({
					viewType: CollectionView.GRID,
					items: this.collection,
					itemView: imageItemView,
					extraParams: {
						onSelect: this.onSelect
					},
					options: {
						filter: false // don't show filter form
					}
				});

				this.$('.js-image-picker-content').html(this.collectionView.$el);

				return this;
			},


			initializeModal: function () {
				this.modal = new ModalView({
					title: 'Välj bild',
					modalContent: this
				});

				this.modal.open();
			},

		});

		return ImagePickerView;

	});
